export const REMOTE_ACCESS_ITEM_MAGIC_LINK = 'MAGIC_LINK';
export const REMOTE_ACCESS_ITEM_PRINT_VIEW = 'PRINT_VIEW';
export type RemoteAccessType = 'MAGIC_LINK';
export const isMagicLink = (item: any) =>
  item?.options?.type === REMOTE_ACCESS_ITEM_MAGIC_LINK;
export const isPrintView = (item: any) =>
  item?.options?.type === REMOTE_ACCESS_ITEM_PRINT_VIEW;
